import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol viewBox=\"0 0 15 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home\">\n<path d=\"M6 14H2V7H0L7.5 0L15 7H13V14H9V9H6V14Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/home.svg
// module id = xaap
// module chunks = 13